// extracted by mini-css-extract-plugin
export default {"not_found":"NotFound_not_found__9Fof0","not_found__link":"NotFound_not_found__link__0uxM1","not_found__text":"NotFound_not_found__text__7fjOC"};